
define(function (require) {
    "use strict";

    var SkillLoadBalanceSectionView = require("user-management-views/skills/SkillLoadBalanceSectionView");

    var SkillLoadBalanceView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillLoadBalanceView = Marionette.CollectionView.extend({

            itemView: SkillLoadBalanceSectionView,

            initialize: function (options) {
                this.agentGroupsCollection = options.agentGroupsCollection;
                this.itemViewOptions = {
                    agentGroupsCollection: this.agentGroupsCollection,
                    channel: options.channel
                };
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillLoadBalanceView;
});




